import { useEffect, useState } from 'react';

/**
 * True once `key` has been on screen for `delayMs`. Used to arm the approve
 * button of a request modal only after the request is visible, so a click
 * aimed at the previous request (or a dApp racing a new one in) can never
 * land on a request the user hasn't seen (ENTX-A-4).
 */
export function useArmDelay(key: string | null, delayMs = 600): boolean {
  const [armedKey, setArmedKey] = useState<string | null>(null);
  useEffect(() => {
    if (key === null) return;
    const timer = setTimeout(() => {
      setArmedKey(key);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [key, delayMs]);
  return key !== null && armedKey === key;
}
